import styled from "styled-components";
import {color} from "../../../../shared/styles";

export const UserName = styled.div`
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
`
export const UserEmail = styled.div`
	color: ${color.secondary.DARK_GREY};
	font-size: 14px;
	font-weight: 300;
	line-height: 20px;
`

export const UserAvatar = styled.img`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	object-fit: cover;
	border: 1px solid #e5e7eb;
`

export const UserInfoWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 10px;
`

export const UserDetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: left;
`